export enum Paths {
	Login = "/login",
	Projects = "/projects",
}
